'use strict';

var React = require('react');
var Classnames = require('classnames');
var _ = require('lodash');
//constants
var FundingYourProductConstants = require('../../constants/FundingYourProductConstants');
var RollOverTypes = FundingYourProductConstants.RollOverTypes;
var FundingTypes = FundingYourProductConstants.FundingTypes;
var FundTypesLabel = FundingYourProductConstants.FundTypesLabel;
var ContributionTypesLabel = FundingYourProductConstants.ContributionTypesLabel;
var SummaryLabels = FundingYourProductConstants.summaryLabels;
//actions
var FundingYourProductActions = require('../../actions/FundingYourProductActions.js');
//components
var ExternalRollover = require('./ExternalRollover.jsx');
var InternalRollover = require('./InternalRollover.jsx');
var OtherFundTypes = require('./OtherFundTypes.jsx');
var FundingYourProductHelper = require('../../utils/FundingYourProductHelper.js');
var CancelDoneButtons = require('../Common/CancelDoneButtons.jsx');
var Validators = require('../../utils/Validators.js');
var Products = require('../../utils/Products.js');
var Formatter = require('../../utils/Formatter.js');

var FundingSummary = React.createClass({
    getInitialState: function () {
        return {
            contributions: this.props.data
        };
    },

    componentWillUpdate: function(nextProps) {
        if (!_.isEqual(nextProps, this.props)) {
            this.setState({ contributions: nextProps.data });
        }
    },

    getCurrentContribution: function (e) {
        var objectIndex = e.currentTarget.id;
        var links = objectIndex.split('-');
        var index = '';
        if (Validators.requiredValidation(links[1])) {
            index = links[1];
        }
        return { contribution: this.state.contributions[index], index: index };
    },

    clickHideShowInvestment: function (e) {
        var current = this.getCurrentContribution(e);
        FundingYourProductActions.updateInvestmentVisibility(!current.contribution.hideInvestments, current.index);
    },

    clickEditContribution: function (e) {
        var current = this.getCurrentContribution(e);
        FundingYourProductActions.startEditMode(current.index);
    },

    clickDeleteContribution: function (e) {
        var current = this.getCurrentContribution(e);
        FundingYourProductActions.deleteFromSummary(current.index);
    },

    getLabels: function () {
        if (Products.isInvestment(this.props.productId)) {
            return FundingYourProductConstants.AmountLabels.INVESTMENT;
        } else {
            return FundingYourProductConstants.AmountLabels.SUPER_PENSION;
        }
    },

    getAmountData: function (data) {
        var amountData = { nameLabel: '', nameValue: '', amountLabel: SummaryLabels.totalAmount, amountValue: '' };
        var labels = this.getLabels();
        if (FundingYourProductHelper.isNonRollover(data.rollOverType)) {
            if (Products.isInvestment(this.props.productId)) {
                if (FundingYourProductHelper.isInternal(data.paymentMethod)) {
                    amountData.nameLabel = SummaryLabels.accNo;
                    amountData.nameValue = data.accountNumber;
                    amountData.amountLabel = data.isPartialRollOver ? labels.partial : labels.full;
                } else {
                    amountData.nameValue = ContributionTypesLabel[data.paymentMethod];
                }

            } else {
                amountData.nameValue = ContributionTypesLabel[data.paymentMethod].toLowerCase();
                amountData.nameLabel = SummaryLabels.via;
            }
        } else {
            amountData.nameLabel = SummaryLabels.accNo;
            amountData.nameValue = data.accountNumber;
            amountData.amountLabel = data.isPartialRollOver ? labels.partial : labels.full;
        }
        amountData.amountValue = data.rollOverAmount;
        return amountData;
    },

    getContributionName: function (data) {
        if (FundingYourProductHelper.isNonRollover(data.rollOverType)) {
            if (Products.isInvestment(this.props.productId)) {
                if (FundingYourProductHelper.isInternal(data.paymentMethod)) {
                    return data.rollOverName;
                } else {
                    return ContributionTypesLabel[data.paymentMethod];
                }
            }
            return FundTypesLabel[data.rollOverType];
        } else {
            if (data.rollOverType === RollOverTypes.EXTERNAL) {
                if (data.rollOverName !== '') {
                    return data.rollOverName;
                }
                return data.rollOverNamePredictive;
            }
            return data.rollOverName;
        }
    },

    cancelEditMode: function (e) {
        var current = this.getCurrentContribution(e);
        FundingYourProductActions.cancelEditMode(current.index);
    },

    finishEditMode: function (e) {
        var current = this.getCurrentContribution(e);
        FundingYourProductActions.endEditMode(current.index);
    },

    finishEditNonRollover: function (e) {
        var current = this.getCurrentContribution(e);
        FundingYourProductActions.endEditNonRollover(current.index);
    },

    render: function () {
        var clickHideShow = this.clickHideShowInvestment;
        var clickEdit = this.clickEditContribution;
        var clickDelete = this.clickDeleteContribution;
        var getAmountData = this.getAmountData;
        var getContributionName = this.getContributionName;
        var cancelEditMode = this.cancelEditMode;
        var finishEditMode = this.finishEditMode;
        var content = this.props.content;
        var isEditMode = this.props.isEditMode;
        var productId = this.props.productId;
        var internalAccounts = this.props.internalAccounts;
        var finishEditNonRollover = this.finishEditNonRollover;
        var bankAccountList = this.props.bankAccountList;
        var hideDirectDebitAddedText = this.props.hideDirectDebitAddedText;
        var directDebitAlreadyAddedText = this.props.directDebitAlreadyAddedText;
        var futureRequestText = this.props.futureRequestText;
        var paymentMethodsInvestment = this.props.paymentMethodsInvestment;
        var internalRolloverInfo = this.props.internalRolloverInfo;
        var usiList = this.props.usiList;
        //render amounts values
        var renderAmountCell = function (data, amountData) {
            return (
            <td className="table-price">
               <strong>
                   ${Formatter.currencyFormat(amountData.amountValue.toString())}
               </strong><br />
               <strong className={Classnames('remaining-balance', { hidden: !data.isPartialRollOver })}>
                   ${data.remainingBalance}
               </strong>
            </td>);
        };

        //render amount labels
        var renderLabelCell = function (data, amountData) {
            return (
                <td className="funding-summary-table-label table-price">
                    <small>
                        {amountData.amountLabel}:
                    </small><br />
                    <small className={Classnames('remaining-balance', { hidden: !data.isPartialRollOver })}>
                        {FundingYourProductConstants.summaryLabels.remainingBalance + ':'}
                    </small>
                </td>
            );
        };

        //render hide/show links
        var renderControls = function (hideInvestments, index) {
            var internalInvestmentId = hideInvestments ? 'fypSummaryShowInvestment-' + index : 'fypSummaryHideInvestment-' + index;
            var internalInvestmentLabel = hideInvestments ? SummaryLabels.showInvestments : SummaryLabels.hideInvestments;
            return <p><a id={internalInvestmentId} onClick={clickHideShow }>{internalInvestmentLabel}</a></p>;
        };

        //render existing investment options
        var renderInvestment = function (data, index) {
            var investment = <span key={index }>- {data.name}: ${data.balance}<br /></span>;
            return investment;
        };

        //render text below the main text
        var renderSubLabels = function (data, index, amountData) {
            var sublabel = amountData.nameLabel && amountData.nameValue
                ? amountData.nameLabel + ' ' + amountData.nameValue
                : '';
            var investments = data.hideInvestments
                ? ''
                : (data.investmentOptions ? data.investmentOptions.map(function (data, index) {
                    return (renderInvestment(data, index));
                }) : '');
            return (
                <p>
                    {sublabel}<br />
                    {investments}
                </p>
            );
        };

        //render contribution cells
        var renderContributionCell = function (data, index, amountData) {
            var contributionName = getContributionName(data);
            return (
            <td>
                {contributionName}
                {renderSubLabels(data, index, amountData)}
                {data.investmentOptions && data.investmentOptions.length > 0 ? renderControls(data.hideInvestments, index) : ''}
            </td>);
        };

        //renders the edit and delete icons
        var renderTools = function (index) {
            var editContributionId = 'fypEditContribution-' + index, deleteContributionId = 'fypDeleteContribution-' + index;
            return (<td className={Classnames('table-tools funding-summary-tools')}>
                        <a className={Classnames('table-pencil', { hidden: isEditMode })} id={editContributionId} onClick={clickEdit}><i className="icon icon-pencil"></i></a>&nbsp;
                        <a className={Classnames('table-cancel', { hidden: isEditMode })} id={deleteContributionId} onClick={clickDelete}><i className="icon icon-cancel"></i></a>
            </td>);
        };

        var renderEditMode = function (data, index) {
            var rollOverCategory;
            if (FundingYourProductHelper.isNonRollover(data.rollOverType)) {
                rollOverCategory = RollOverTypes.NON_ROLLOVER;
            }
            else {
                rollOverCategory = data.rollOverType;
            }
            switch (rollOverCategory) {
                case RollOverTypes.INTERNAL:
                    var internalLabel = Products.isInvestment(productId) ? SummaryLabels.internalTransfer : SummaryLabels.internalRollover;
                    return <tr key={index}>
                               <td colSpan="4">
                                   <div id={'fypEditInternalRollover'+index}>
                                       <div className="form-label-section">
                                           <label><strong>{internalLabel}</strong></label>
                                       </div>
                                       <InternalRollover content={content}
                                                         activeFundType={FundingTypes.Internal_rollover}
                                                         data={data}
                                                         inSummary={true}
                                                         index={index}
                                                         product={productId}
                                                         internalAccounts={internalAccounts}
                                                         onCancelClick={cancelEditMode}
                                                         onDoneClick={finishEditMode}
                                                         internalRolloverInfo={internalRolloverInfo} />
                                    </div>
                                </td>
                            </tr>;
                case RollOverTypes.EXTERNAL:
                    return <tr key={index}>
                           <td colSpan="4">
                               <div id={'fypEditExternalRollover'+index}>
                                   <div className="form-label-section">
                                       <label><strong>{SummaryLabels.externalRollover}</strong></label>
                                   </div>
                                   <ExternalRollover content={content}
                                                     activeFundType={FundingTypes.External_rollover}
                                                     data={data}
                                                     usiList={usiList}
                                                     inSummary={true}
                                                     index={index}
                                                     onCancelClick={cancelEditMode}
                                                     onDoneClick={finishEditMode} />
                               </div>
                           </td>
                    </tr>;
                case RollOverTypes.NON_ROLLOVER:
                    var contributionName = getContributionName(data);
                    return <tr key={index}>
                           <td colSpan="4">
                               <div id={'fypEditNonRollover'+index}>
                                   <div className="form-label-section">
                                       <label><strong>{contributionName}</strong></label>
                                   </div>
                                   <OtherFundTypes product={productId}
                                                   content={content}
                                                   activeFundType={data.rollOverType}
                                                   data={data}
                                                   inSummary={true}
                                                   index={index}                                                  
                                                   onCancelClick={cancelEditMode}
                                                   onDoneClick={finishEditNonRollover}
                                                   bankAccountList={bankAccountList}
                                                   hideDirectDebitAddedText = {hideDirectDebitAddedText}
                                                   directDebitAlreadyAddedText={directDebitAlreadyAddedText}
                                                   futureRequestText={futureRequestText}
                                                   paymentMethodsInvestment={paymentMethodsInvestment}
                                                   internalRolloverInfo={internalRolloverInfo} />
                                </div>
                           </td>
                           </tr>;
                default:
                    return <tr key={index}>
                    <td colSpan="4">
                        supposed to be edit mode..
                    </td>
                    <td>
                        <CancelDoneButtons id="summaryFormButton"
                                           index={index}
                                           onClickCancel={cancelEditMode}
                                           onClickDone={finishEditMode} />
                    </td>
                    </tr>;
            }
        };

        //renders a new row
        var renderContributionRow = function (data, index) {
            var amountData = getAmountData(data);
            if (data.isEdit) {
                return renderEditMode(data, index);
            } else {
                return <tr key={index} id={'fypSummaryRow' + index}>
                    {renderContributionCell(data, index, amountData)}
                    {renderLabelCell(data, amountData)}
                    {renderAmountCell(data, amountData)}
                    {renderTools(index)}
                </tr>;
            }
        };

        return (
            <table id="fypSummaryTable" className="table">
                <tbody>
                    {this.state.contributions.map(function (data, index) {
                        return renderContributionRow(data, index);
                    })}
                </tbody>
            </table>
        );
    }
});

module.exports = FundingSummary;


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/FundingYourProduct/FundingSummary.jsx